import { render, staticRenderFns } from "./TimeToKill.vue?vue&type=template&id=5022e620&scoped=true&"
import script from "./TimeToKill.vue?vue&type=script&lang=js&"
export * from "./TimeToKill.vue?vue&type=script&lang=js&"
import style0 from "./TimeToKill.vue?vue&type=style&index=0&id=5022e620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022e620",
  null
  
)

export default component.exports